import { getServices } from "../platform.js";

export const APP_PREFERENCES_ID = "app_preferences_v1";
export const PREFERENCES_CREATED_AT_KEY = "preferences_created_at";
export const PREFERENCES_UPDATED_AT_KEY = "preferences_updated_at";

export async function touchPreferencesUpdatedAt(at = new Date().toISOString()): Promise<void> {
  const { settings } = getServices();
  if (!(await settings.get(PREFERENCES_CREATED_AT_KEY))) {
    await settings.set(PREFERENCES_CREATED_AT_KEY, at);
  }
  await settings.set(PREFERENCES_UPDATED_AT_KEY, at);
}

export async function setPreferencesSyncClock(createdAt: string, updatedAt: string): Promise<void> {
  const { settings } = getServices();
  await settings.set(PREFERENCES_CREATED_AT_KEY, createdAt);
  await settings.set(PREFERENCES_UPDATED_AT_KEY, updatedAt);
}
